import { Container, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import * as textBodyMessage from "../Services/textBody";
import ExpertTechno from "../components/ExpertTechno";
import SectionHeader from "../components/SectionHeader";
import SkillBodyText from "./SkillBodyText";
import SkillsProgress from "./SkillsProgress";
import SkillProfessionalExperience from "./SkillProfessionalExperience";

const useStyles = makeStyles({
  skillProgress: {
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center",
  },
});

function SkillsExperience() {
  const classes = useStyles();
  return (
    <Container maxWidth="lg" sx={{ minHeight: "100vh" }} id="skill-container">
      <SectionHeader
        sectionTitle={textBodyMessage.skillExperience.pageTitle.toUpperCase()}
      />
      <Grid container spacing={5} mb={5}>
        <Grid item xs={12} md={6} className={classes.skillProgress}>
          <SkillsProgress skills={textBodyMessage.skills} />
          <SkillBodyText
            skillText={textBodyMessage.skillExperience.skillText}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SkillProfessionalExperience
            skillProfessionsList={textBodyMessage.skillProfessionsList}
          />
        </Grid>
      </Grid>
      <ExpertTechno />
    </Container>
  );
}

export default SkillsExperience;
